import {fromJS} from 'immutable';
import overviewActions from '../actions/overview.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    backgroundImage: '',
    description: '',
    faq: {},
    carousel: {},
    title: '',
    warningText: '',
    benefitsSection: {},
    imageArray: {}
});

export const overviewReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case overviewActions.TYPES.GET_HOME_COMPLETE: {
            const {data} = action.payload.home;

            if (data) {
                const {
                    backgroundImage,
                    description,
                    faq,
                    carousel,
                    title,
                    warningText,
                    benefitsSection,
                    imageArray
                } = data;
                newState = fromJS({
                    backgroundImage,
                    description,
                    faq,
                    carousel,
                    title,
                    warningText,
                    benefitsSection,
                    imageArray
                });
            }
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('overview', overviewReducer);
